import type {
  SessionTutorialMode,
  SessionTutorialStepCopy,
  SessionTutorialStepId,
  SessionTutorialTipStepId,
} from '@/features/session-tutorial/sessionTutorial.types';

export const DESKTOP_STEPS: SessionTutorialStepId[] = ['template', 'record', 'demo', 'summary', 'result'];
export const MOBILE_STEPS: SessionTutorialStepId[] = ['mobileRecord', 'demo', 'mobileAssistant', 'summary', 'result'];

/** Tips that are only read: the highlighted part stays out of reach too (the note cannot be edited). */
export const READ_ONLY_STEPS: ReadonlySet<SessionTutorialStepId> = new Set(['result']);

/** Tips that wait for the person to do it themselves (no "Áfram"): only the note at the end is read. */
export const ACTION_STEPS: ReadonlySet<SessionTutorialStepId> = new Set([
  'template',
  'record',
  'mobileRecord',
  'mobileAssistant',
  'summary',
]);

const templateTip: SessionTutorialStepCopy = {
  title: 'Veldu sniðmát',
  body: 'Sniðmátið ræður uppbyggingu nótunnar. Veldu sniðmát til að halda áfram. Augað við hliðina opnar það til að breyta.',
};

const resultTip: SessionTutorialStepCopy = {
  title: 'Nótan þín',
  body: 'Svona verður nótan með sniðmátinu og stílnum sem þú valdir. Dæmið hverfur þegar þú lýkur kynningunni.',
};

const conversationRecord: SessionTutorialStepCopy = {
  title: 'Hefja upptöku',
  body: 'Í viðtali smellir þú hér til að hefja upptöku. Smelltu núna til að sjá dæmi um viðtal; ekkert er tekið upp.',
};

const dictationRecord: SessionTutorialStepCopy = {
  title: 'Hefja upptöku',
  body: 'Hér smellir þú til að lesa inn nótuna. Smelltu núna til að sjá dæmi um dikteringu; ekkert er tekið upp.',
};

export const sessionTutorialContent: Record<
  SessionTutorialMode,
  Record<SessionTutorialTipStepId, SessionTutorialStepCopy>
> = {
  conversation: {
    template: templateTip,
    record: conversationRecord,
    mobileRecord: conversationRecord,
    summary: {
      title: 'Búðu til samantekt',
      body: 'Smelltu á „Búa til samantekt“ til að sjá Skríbuna skrifa nótu úr dæminu.',
    },
    result: resultTip,
    mobileAssistant: {
      title: 'Klínísk aðstoð',
      body: 'Hér eru sniðmátið og samantektin. Opnaðu flipann til að halda áfram.',
    },
  },
  dictation: {
    template: templateTip,
    record: dictationRecord,
    mobileRecord: dictationRecord,
    summary: {
      title: 'Búðu til nótu',
      body: 'Smelltu á „Búa til nótu“ til að sjá Skríbuna skrifa nótu úr dæminu.',
    },
    result: resultTip,
    mobileAssistant: {
      title: 'Klínísk aðstoð',
      body: 'Hér eru sniðmátið og nótan. Opnaðu flipann til að halda áfram.',
    },
  },
};

export const sessionTutorialNav = {
  skip: 'Sleppa',
  next: 'Áfram',
  done: 'Skilið',
  progress: (step: number, total: number) => `${step} af ${total}`,
  demoBadge: 'Sýnidæmi - Þetta eru gervigögn',
  skipTour: 'Sleppa kynningu',
  listeningHint: 'Talrit mun birtast hér um leið og hljóð heyrist.',
};
